import {inject, Pipe, PipeTransform} from '@angular/core';
import {DANISH_DATE_SEPARATOR, formatDateTime, TranslateService} from '@brunata-angular/util';
import {DateTime, DateTimeFormatOptions} from 'luxon';

@Pipe({
    name: 'appdateshortyear',
    standalone: true,
})
export class DateShortYearPipe implements PipeTransform {
    private translateService = inject(TranslateService);
    private readonly danishDateSeparator = inject(DANISH_DATE_SEPARATOR);
    private dateFormat: DateTimeFormatOptions = {year: '2-digit', month: '2-digit', day: '2-digit'};

    transform(value: DateTime | null): string {
        if (value == null || !value.isValid) {
            return '';
        }
        return formatDateTime(
            value,
            this.translateService.language,
            this.dateFormat,
            this.danishDateSeparator,
        );
    }
}
